import { KlarnaConfig, KlarnaLocale } from '@components/bucketTest/klarna/klarna.interface';
import KlarnaCountries from '@components/bucketTest/klarna/klarna-locales.json';
import { Preferences } from '@interfaces/models/preferences';

export class KlarnaOSMService {
  static regionConfigs = {
    us: {
      src: 'https://js.klarna.com/web-sdk/v1/klarna.js',
      clientId: 'c1903bbe-a71d-538c-a24b-9a0a7a8ad4a3',
    },
    eu: {
      src: 'https://js.klarna.com/web-sdk/v1/klarna.js',
      clientId: '878ebceb-ead1-5938-a7df-9bc5fd01d9bb',
    },
    oc: {
      src: 'https://js.klarna.com/web-sdk/v1/klarna.js',
      clientId: 'df427f02-d361-543e-9a1a-f29a9be20b2d',
    },
  };

  static filterByLocale({ language, country }: Partial<Preferences>): KlarnaLocale[] {
    return KlarnaCountries.filter((x) => x.supportedLocales.includes(`${language}-${country}`));
  }

  static filterByCountry(country: string): KlarnaLocale[] {
    return KlarnaCountries.filter((x) => x.purchaseCountry === country);
  }

  // We need to return Maybe type
  static getConfigs({ currency, language, country }: Partial<Preferences>): KlarnaConfig | undefined {
    const [filteredCountry] = KlarnaOSMService.filterByLocale({
      country,
      language,
    }).filter((x) => x.supportedCurrency.includes(currency));
    return KlarnaOSMService.regionConfigs[filteredCountry?.region];
  }
}

export default {};
